export type DiscountType = "percent" | "amount" | "price";

export function calculateDiscountAmount(
  moneyValue: number,
  discountType: DiscountType,
  discountValue: number
): number {
  let discountAmount: number = 0;

  switch (discountType) {
    case "percent":
      discountAmount = moneyValue * (discountValue / 100);
      break;
    case "amount":
      discountAmount = discountValue;
      break;
    case "price":
      discountAmount = moneyValue - discountValue;
      break;
  }

  return discountAmount;
}
